import script from "./tableModal.vue?vue&type=script&setup=true&name=tableModal&lang=js"
export * from "./tableModal.vue?vue&type=script&setup=true&name=tableModal&lang=js"

import "./tableModal.vue?vue&type=style&index=0&id=f47a8e24&lang=less&scoped=true"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f47a8e24"]])

export default __exports__